export default __webpack_public_path__ + "static/media/aws-iam.068afee2.svg";